// SAP Country Translation Utility
// Translates German country names to localized display names

import i18n from '../i18n';

// German country names and their translations
const SAP_TRANSLATIONS: Record<string, Record<string, Record<string, string>>> = {
  // Country names (Land)
  land: {
    en: {
      // German-speaking countries
      'Deutschland': 'Germany',
      'Österreich': 'Austria',
      'Schweiz': 'Switzerland',
      'Liechtenstein': 'Liechtenstein',
      
      // Western Europe
      'Frankreich': 'France',
      'Italien': 'Italy',
      'Spanien': 'Spain',
      'Portugal': 'Portugal',
      'Niederlande': 'Netherlands',
      'Belgien': 'Belgium',
      'Luxemburg': 'Luxembourg',
      'Monaco': 'Monaco',
      'Andorra': 'Andorra',
      'San Marino': 'San Marino',
      'Vatikanstadt': 'Vatican City',
      
      // British Isles
      'Vereinigtes Königreich': 'United Kingdom',
      'Großbritannien': 'Great Britain',
      'England': 'England',
      'Schottland': 'Scotland',
      'Wales': 'Wales',
      'Nordirland': 'Northern Ireland',
      'Irland': 'Ireland',
      'Isle of Man': 'Isle of Man',
      
      // Nordic countries
      'Norwegen': 'Norway',
      'Schweden': 'Sweden',
      'Dänemark': 'Denmark',
      'Finnland': 'Finland',
      'Island': 'Iceland',
      'Färöer': 'Faroe Islands',
      'Grönland': 'Greenland',
      
      // Eastern Europe
      'Polen': 'Poland',
      'Tschechien': 'Czech Republic',
      'Tschechische Republik': 'Czech Republic',
      'Slowakei': 'Slovakia',
      'Ungarn': 'Hungary',
      'Slowenien': 'Slovenia',
      'Kroatien': 'Croatia',
      'Bosnien und Herzegowina': 'Bosnia and Herzegovina',
      'Serbien': 'Serbia',
      'Montenegro': 'Montenegro',
      'Nordmazedonien': 'North Macedonia',
      'Albanien': 'Albania',
      'Kosovo': 'Kosovo',
      
      // Baltic states
      'Litauen': 'Lithuania',
      'Lettland': 'Latvia',
      'Estland': 'Estonia',
      
      // Southeast Europe
      'Rumänien': 'Romania',
      'Bulgarien': 'Bulgaria',
      'Griechenland': 'Greece',
      'Türkei': 'Turkey',
      'Zypern': 'Cyprus',
      'Malta': 'Malta',
      
      // Eastern Europe/Asia
      'Russland': 'Russia',
      'Ukraine': 'Ukraine',
      'Belarus': 'Belarus',
      'Weißrussland': 'Belarus',
      'Moldau': 'Moldova',
      'Georgien': 'Georgia',
      'Armenien': 'Armenia',
      'Aserbaidschan': 'Azerbaijan',
      'Kasachstan': 'Kazakhstan',
      
      // Middle East
      'Israel': 'Israel',
      'Jordanien': 'Jordan',
      'Libanon': 'Lebanon',
      'Syrien': 'Syria',
      'Irak': 'Iraq',
      'Iran': 'Iran',
      'Saudi-Arabien': 'Saudi Arabia',
      'Vereinigte Arabische Emirate': 'United Arab Emirates',
      'Katar': 'Qatar',
      'Kuwait': 'Kuwait',
      'Bahrain': 'Bahrain',
      'Oman': 'Oman',
      'Jemen': 'Yemen',
      
      // North Africa
      'Ägypten': 'Egypt',
      'Libyen': 'Libya',
      'Tunesien': 'Tunisia',
      'Algerien': 'Algeria',
      'Marokko': 'Morocco',
      'Sudan': 'Sudan',
      'Äthiopien': 'Ethiopia',
      'Südafrika': 'South Africa',
      
      // Asia
      'China': 'China',
      'Japan': 'Japan',
      'Südkorea': 'South Korea',
      'Nordkorea': 'North Korea',
      'Indien': 'India',
      'Pakistan': 'Pakistan',
      'Bangladesch': 'Bangladesh',
      'Sri Lanka': 'Sri Lanka',
      'Thailand': 'Thailand',
      'Vietnam': 'Vietnam',
      'Malaysia': 'Malaysia',
      'Singapur': 'Singapore',
      'Indonesien': 'Indonesia',
      'Philippinen': 'Philippines',
      'Australien': 'Australia',
      'Neuseeland': 'New Zealand',
      
      // Americas
      'Vereinigte Staaten': 'United States',
      'USA': 'USA',
      'Kanada': 'Canada',
      'Mexiko': 'Mexico',
      'Brasilien': 'Brazil',
      'Argentinien': 'Argentina',
      'Chile': 'Chile',
      'Kolumbien': 'Colombia',
      'Venezuela': 'Venezuela',
      'Peru': 'Peru',
      'Ecuador': 'Ecuador',
      'Uruguay': 'Uruguay',
      'Paraguay': 'Paraguay',
      'Bolivien': 'Bolivia',
      
      // Africa
      'Nigeria': 'Nigeria',
      'Kenia': 'Kenya',
      'Ghana': 'Ghana'
    },
    de: {
      // German-speaking countries
      'Deutschland': 'Deutschland',
      'Österreich': 'Österreich',
      'Schweiz': 'Schweiz',
      'Liechtenstein': 'Liechtenstein',
      
      // Western Europe
      'Frankreich': 'Frankreich',
      'Italien': 'Italien',
      'Spanien': 'Spanien',
      'Portugal': 'Portugal',
      'Niederlande': 'Niederlande',
      'Belgien': 'Belgien',
      'Luxemburg': 'Luxemburg',
      'Monaco': 'Monaco',
      'Andorra': 'Andorra',
      'San Marino': 'San Marino',
      'Vatikanstadt': 'Vatikanstadt',
      
      // British Isles
      'Vereinigtes Königreich': 'Vereinigtes Königreich',
      'Großbritannien': 'Großbritannien',
      'England': 'England',
      'Schottland': 'Schottland',
      'Wales': 'Wales',
      'Nordirland': 'Nordirland',
      'Irland': 'Irland',
      'Isle of Man': 'Isle of Man',
      
      // Nordic countries
      'Norwegen': 'Norwegen',
      'Schweden': 'Schweden',
      'Dänemark': 'Dänemark',
      'Finnland': 'Finnland',
      'Island': 'Island',
      'Färöer': 'Färöer',
      'Grönland': 'Grönland',
      
      // Eastern Europe
      'Polen': 'Polen',
      'Tschechien': 'Tschechien',
      'Tschechische Republik': 'Tschechische Republik',
      'Slowakei': 'Slowakei',
      'Ungarn': 'Ungarn',
      'Slowenien': 'Slowenien',
      'Kroatien': 'Kroatien',
      'Bosnien und Herzegowina': 'Bosnien und Herzegowina',
      'Serbien': 'Serbien',
      'Montenegro': 'Montenegro',
      'Nordmazedonien': 'Nordmazedonien',
      'Albanien': 'Albanien',
      'Kosovo': 'Kosovo',
      
      // Baltic states
      'Litauen': 'Litauen',
      'Lettland': 'Lettland',
      'Estland': 'Estland',
      
      // Southeast Europe
      'Rumänien': 'Rumänien',
      'Bulgarien': 'Bulgarien',
      'Griechenland': 'Griechenland',
      'Türkei': 'Türkei',
      'Zypern': 'Zypern',
      'Malta': 'Malta',
      
      // Eastern Europe/Asia
      'Russland': 'Russland',
      'Ukraine': 'Ukraine',
      'Belarus': 'Belarus',
      'Weißrussland': 'Weißrussland',
      'Moldau': 'Moldau',
      'Georgien': 'Georgien',
      'Armenien': 'Armenien',
      'Aserbaidschan': 'Aserbaidschan',
      'Kasachstan': 'Kasachstan',
      
      // Middle East
      'Israel': 'Israel',
      'Jordanien': 'Jordanien',
      'Libanon': 'Libanon',
      'Syrien': 'Syrien',
      'Irak': 'Irak',
      'Iran': 'Iran',
      'Saudi-Arabien': 'Saudi-Arabien',
      'Vereinigte Arabische Emirate': 'Vereinigte Arabische Emirate',
      'Katar': 'Katar',
      'Kuwait': 'Kuwait',
      'Bahrain': 'Bahrain',
      'Oman': 'Oman',
      'Jemen': 'Jemen',
      
      // North Africa
      'Ägypten': 'Ägypten',
      'Libyen': 'Libyen',
      'Tunesien': 'Tunesien',
      'Algerien': 'Algerien',
      'Marokko': 'Marokko',
      'Sudan': 'Sudan',
      'Äthiopien': 'Äthiopien',
      'Südafrika': 'Südafrika',
      
      // Asia
      'China': 'China',
      'Japan': 'Japan',
      'Südkorea': 'Südkorea',
      'Nordkorea': 'Nordkorea',
      'Indien': 'Indien',
      'Pakistan': 'Pakistan',
      'Bangladesch': 'Bangladesch',
      'Sri Lanka': 'Sri Lanka',
      'Thailand': 'Thailand',
      'Vietnam': 'Vietnam',
      'Malaysia': 'Malaysia',
      'Singapur': 'Singapur',
      'Indonesien': 'Indonesien',
      'Philippinen': 'Philippinen',
      'Australien': 'Australien',
      'Neuseeland': 'Neuseeland',
      
      // Americas
      'Vereinigte Staaten': 'Vereinigte Staaten',
      'USA': 'USA',
      'Kanada': 'Kanada',
      'Mexiko': 'Mexiko',
      'Brasilien': 'Brasilien',
      'Argentinien': 'Argentinien',
      'Chile': 'Chile',
      'Kolumbien': 'Kolumbien',
      'Venezuela': 'Venezuela',
      'Peru': 'Peru',
      'Ecuador': 'Ecuador',
      'Uruguay': 'Uruguay',
      'Paraguay': 'Paraguay',
      'Bolivien': 'Bolivien',
      
      // Africa
      'Nigeria': 'Nigeria',
      'Kenia': 'Kenia',
      'Ghana': 'Ghana'
    },
    fr: {
      // German-speaking countries
      'Deutschland': 'Allemagne',
      'Österreich': 'Autriche',
      'Schweiz': 'Suisse',
      'Liechtenstein': 'Liechtenstein',
      
      // Western Europe
      'Frankreich': 'France',
      'Italien': 'Italie',
      'Spanien': 'Espagne',
      'Portugal': 'Portugal',
      'Niederlande': 'Pays-Bas',
      'Belgien': 'Belgique',
      'Luxemburg': 'Luxembourg',
      'Monaco': 'Monaco',
      'Andorra': 'Andorre',
      'San Marino': 'Saint-Marin',
      'Vatikanstadt': 'Vatican',
      
      // British Isles
      'Vereinigtes Königreich': 'Royaume-Uni',
      'Großbritannien': 'Grande-Bretagne',
      'England': 'Angleterre',
      'Schottland': 'Écosse',
      'Wales': 'Pays de Galles',
      'Nordirland': 'Irlande du Nord',
      'Irland': 'Irlande',
      'Isle of Man': 'Île de Man',
      
      // Nordic countries
      'Norwegen': 'Norvège',
      'Schweden': 'Suède',
      'Dänemark': 'Danemark',
      'Finnland': 'Finlande',
      'Island': 'Islande',
      'Färöer': 'Îles Féroé',
      'Grönland': 'Groenland',
      
      // Eastern Europe
      'Polen': 'Pologne',
      'Tschechien': 'République tchèque',
      'Tschechische Republik': 'République tchèque',
      'Slowakei': 'Slovaquie',
      'Ungarn': 'Hongrie',
      'Slowenien': 'Slovénie',
      'Kroatien': 'Croatie',
      'Bosnien und Herzegowina': 'Bosnie-Herzégovine',
      'Serbien': 'Serbie',
      'Montenegro': 'Monténégro',
      'Nordmazedonien': 'Macédoine du Nord',
      'Albanien': 'Albanie',
      'Kosovo': 'Kosovo',
      
      // Baltic states
      'Litauen': 'Lituanie',
      'Lettland': 'Lettonie',
      'Estland': 'Estonie',
      
      // Southeast Europe
      'Rumänien': 'Roumanie',
      'Bulgarien': 'Bulgarie',
      'Griechenland': 'Grèce',
      'Türkei': 'Turquie',
      'Zypern': 'Chypre',
      'Malta': 'Malte',
      
      // Eastern Europe/Asia
      'Russland': 'Russie',
      'Ukraine': 'Ukraine',
      'Belarus': 'Biélorussie',
      'Weißrussland': 'Biélorussie',
      'Moldau': 'Moldavie',
      'Georgien': 'Géorgie',
      'Armenien': 'Arménie',
      'Aserbaidschan': 'Azerbaïdjan',
      'Kasachstan': 'Kazakhstan',
      
      // Middle East
      'Israel': 'Israël',
      'Jordanien': 'Jordanie',
      'Libanon': 'Liban',
      'Syrien': 'Syrie',
      'Irak': 'Irak',
      'Iran': 'Iran',
      'Saudi-Arabien': 'Arabie saoudite',
      'Vereinigte Arabische Emirate': 'Émirats arabes unis',
      'Katar': 'Qatar',
      'Kuwait': 'Koweït',
      'Bahrain': 'Bahreïn',
      'Oman': 'Oman',
      'Jemen': 'Yémen',
      
      // North Africa
      'Ägypten': 'Égypte',
      'Libyen': 'Libye',
      'Tunesien': 'Tunisie',
      'Algerien': 'Algérie',
      'Marokko': 'Maroc',
      'Sudan': 'Soudan',
      'Äthiopien': 'Éthiopie',
      'Südafrika': 'Afrique du Sud',
      
      // Asia
      'China': 'Chine',
      'Japan': 'Japon',
      'Südkorea': 'Corée du Sud',
      'Nordkorea': 'Corée du Nord',
      'Indien': 'Inde',
      'Pakistan': 'Pakistan',
      'Bangladesch': 'Bangladesh',
      'Sri Lanka': 'Sri Lanka',
      'Thailand': 'Thaïlande',
      'Vietnam': 'Vietnam',
      'Malaysia': 'Malaisie',
      'Singapur': 'Singapour',
      'Indonesien': 'Indonésie',
      'Philippinen': 'Philippines',
      'Australien': 'Australie',
      'Neuseeland': 'Nouvelle-Zélande',
      
      // Americas
      'Vereinigte Staaten': 'États-Unis',
      'USA': 'États-Unis',
      'Kanada': 'Canada',
      'Mexiko': 'Mexique',
      'Brasilien': 'Brésil',
      'Argentinien': 'Argentine',
      'Chile': 'Chili',
      'Kolumbien': 'Colombie',
      'Venezuela': 'Venezuela',
      'Peru': 'Pérou',
      'Ecuador': 'Équateur',
      'Uruguay': 'Uruguay',
      'Paraguay': 'Paraguay',
      'Bolivien': 'Bolivie',
      
      // Africa
      'Nigeria': 'Nigeria',
      'Kenia': 'Kenya',
      'Ghana': 'Ghana'
    }
  }
};

/**
 * Translates a German country name to the current language
 * @param germanCountryName - The German country name from SAP
 * @param targetLanguage - Optional target language (defaults to current i18n language)
 * @returns Translated country name or original value if no translation found
 */
export function translateCountryName(germanCountryName: string, targetLanguage?: string): string {
  const currentLang = targetLanguage || i18n.language || 'en';
  
  // Get the translation category
  const countryTranslations = SAP_TRANSLATIONS.land;
  if (!countryTranslations) {
    console.warn(`🌐 Country Translation: No country translations available`);
    return germanCountryName;
  }

  // Get translations for the target language
  const languageTranslations = countryTranslations[currentLang];
  if (!languageTranslations) {
    console.warn(`🌐 Country Translation: No translations available for language '${currentLang}'`);
    return germanCountryName;
  }

  // Look for exact match first
  const exactTranslation = languageTranslations[germanCountryName];
  if (exactTranslation) {
    return exactTranslation;
  }

  // Try partial matching for compound words
  const partialMatch = Object.keys(languageTranslations).find(key => 
    germanCountryName.includes(key) || key.includes(germanCountryName)
  );
  
  if (partialMatch) {
    return languageTranslations[partialMatch];
  }

  // No translation found, return original
  return germanCountryName;
}

// Machine type categorization based on MODEL_TO_FOLDER mapping
const MACHINE_TYPE_CATEGORIES: Record<string, string> = {
  // Packer machines
  'M350': 'packer',
  'M353': 'packer', 
  'M550': 'packer',
  'M552': 'packer',
  'M553': 'packer', 
  'M701': 'packer',
  'M703': 'packer',
  'M725': 'packer',
  'Hi5Packer': 'packer',
  'HiP': 'packer',
  'HIP': 'packer',
  
  // Wrapper machines
  'M401': 'wrapper',
  'M404': 'wrapper',
  'M751': 'wrapper',
  'M752': 'wrapper',
  'M753': 'wrapper',
  'HiC': 'wrapper',
  'HIC': 'wrapper',
  
  // Boxer machines
  'M411': 'boxer',
  'M413': 'boxer',
  'M418': 'boxer',
  'M779': 'boxer',
  'HiB': 'boxer',
  'HIB': 'boxer',
  
  // RYO machines  
  'M052': 'RYO',
  'M200-HS': 'RYO',
  'M203-S-Bobin': 'RYO',
  'M203-S-Magazin': 'RYO', 
  'M242': 'RYO',
  'M252-0,5': 'RYO',
  'M252': 'RYO',
  'M507-OCS': 'RYO',
  
  // Case packer machines
  'M459': 'case_packer'
};

/**
 * Find a known model key occurring as a whole word anywhere in `text`.
 *
 * Longest keys are tried first so "M200-HS" wins over "M200", and "Hi5Packer"
 * over any shorter prefix. Matching is case-insensitive but the returned value
 * is the canonical key from the map, so callers can index it directly.
 */
function findModelToken(text: string, keys: Record<string, string>): string {
  const candidates = Object.keys(keys).sort((a, b) => b.length - a.length);
  for (const key of candidates) {
    // Escape regex metacharacters — keys contain '-' and ',' (e.g. "M252-0,5").
    const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // Bounded by start/end or a non-alphanumeric char, so "HIP" doesn't match
    // inside "HIPX" and "M350" doesn't match inside "M3501".
    if (new RegExp(`(?:^|[^A-Za-z0-9])${escaped}(?![A-Za-z0-9])`, 'i').test(text)) {
      return key;
    }
  }
  return '';
}

/**
 * Extract model name from machine type and return its category
 */
function extractModelFromMachineType(machineType: string): string {
  if (!machineType) return '';
  
  const cleaned = machineType.trim();
  
  // Check if it's already a known model name (case-sensitive first)
  if (MACHINE_TYPE_CATEGORIES[cleaned]) {
    return cleaned;
  }
  
  // Check for case-insensitive match
  const upperCleaned = cleaned.toUpperCase();
  if (MACHINE_TYPE_CATEGORIES[upperCleaned]) {
    return upperCleaned;
  }
  
  // Remove "Modell" prefix and try again
  const withoutModell = cleaned.replace(/^Modell\s+/i, '').trim();
  if (withoutModell !== cleaned) {
    if (MACHINE_TYPE_CATEGORIES[withoutModell]) {
      return withoutModell;
    }
    
    const upperWithoutModell = withoutModell.toUpperCase();
    if (MACHINE_TYPE_CATEGORIES[upperWithoutModell]) {
      return upperWithoutModell;
    }
  }
  
  // Handle patterns like "packer (M350)" or "case_packer (M459)"
  const parenthesesPattern = cleaned.match(/\(([^)]+)\)/);
  if (parenthesesPattern) {
    const candidate = parenthesesPattern[1].toUpperCase();
    if (MACHINE_TYPE_CATEGORIES[candidate]) {
      return candidate;
    }
  }

  // Scan for a known model token ANYWHERE in the string. Names commonly arrive
  // prefixed with the machine number — e.g. "22547 - Modell HIP" — where the
  // leading-"Modell" strip above doesn't apply and the numeric fallbacks below
  // would otherwise match the machine number ("M22547") and yield 'unknown'.
  const token = findModelToken(cleaned, MACHINE_TYPE_CATEGORIES);
  if (token) {
    return token;
  }
  
  // Handle patterns like "Modell 350" or "Model 052"
  const modellPattern = cleaned.match(/(?:modell?|model)\s*(\d+)/i);
  if (modellPattern) {
    const candidate = `M${modellPattern[1]}`;
    if (MACHINE_TYPE_CATEGORIES[candidate]) {
      return candidate;
    }
  }
  
  // Try to extract M + numbers pattern (M350, M703, etc.)
  const mPattern = cleaned.match(/M\d+[\w-]*/i);
  if (mPattern) {
    const candidate = mPattern[0].toUpperCase();
    if (MACHINE_TYPE_CATEGORIES[candidate]) {
      return candidate;
    }
  }
  
  // Try to extract just numbers and add M prefix
  const numberPattern = cleaned.match(/\d+/);
  if (numberPattern) {
    const candidate = `M${numberPattern[0]}`;
    if (MACHINE_TYPE_CATEGORIES[candidate]) {
      return candidate;
    }
  }
  
  return '';
}

export function getMachineTypeCategory(machineType: string): string {
  const modelName = extractModelFromMachineType(machineType);
  if (modelName && MACHINE_TYPE_CATEGORIES[modelName]) {
    return MACHINE_TYPE_CATEGORIES[modelName];
  }
  return 'unknown';
}

// Legacy function aliases for backward compatibility
export function translateMachineType(bautyp: string, _language?: string): string {
  // Remove "Modell" prefix if present
  const cleaned = bautyp?.replace(/^Modell\s+/i, '').trim() || bautyp;
  return cleaned;
}

export function translateLineName(lineName: string, _language?: string): string {
  // For now, just return the original line name
  return lineName;
}

export function translateFactoryName(werkName: string, _language?: string): string {
  // For now, just return the original factory name
  return werkName;
}

export function translateStatus(status: string): string {
  // For now, just return the original status
  return status;
}
